import { render, staticRenderFns } from "./ListHimmoku.vue?vue&type=template&id=65968acb&"
import script from "./ListHimmoku.vue?vue&type=script&lang=ts&"
export * from "./ListHimmoku.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports